module.exports = __webpack_public_path__ + "img/rec-14.2b03f767.png";